export const Theme = {
  container: 'flex z-[9999] bg-danger overflow-y-auto overflow-x-hidden fixed top-0 left-0 justify-center items-center w-full h-full',
  wrapper: 'relative ws:p-2 p-4 w-full max-w-2xl max-h-full',
  content: 'relative overflow-hidden bg-white rounded-lg shadow dark:bg-gray-700',
  backdrop: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[999]'
};

export const DialogSize = {
  xs: 'max-w-xl',
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl'
};
